import { render, staticRenderFns } from "./LeadDetail1.vue?vue&type=template&id=6660cce2&"
import script from "./LeadDetail1.vue?vue&type=script&lang=js&"
export * from "./LeadDetail1.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetail1.vue?vue&type=style&index=0&id=6660cce2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports